import { SearchBoxController, SearchBoxComponent } from './search_input_box/search_input_box_controller';

angular
  .module('ui-ng-search-box', [])
  .controller('SearchBoxController', SearchBoxController)
  .component('searchInputBox', new SearchBoxComponent());



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-search-box/src/main.ts